import { render, staticRenderFns } from "./ProfileSocials.vue?vue&type=template&id=13bbd11e&scoped=true"
import script from "./ProfileSocials.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSocials.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSocials.vue?vue&type=style&index=0&id=13bbd11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbd11e",
  null
  
)

export default component.exports